import { MeasurementSettings, MeasurementSettingsResponse } from '../types';

export function transformMeasurementSettingsResponse<T extends MeasurementSettingsResponse>(
  data: T,
): MeasurementSettings | null {
  const products = data?.products || [];
  const settingsData = { step: products[0]?.step };
  if (typeof settingsData.step === 'object' || !settingsData.step) {
    throw new Error('NOT_FOUND');
  }
  return settingsData;
}
